import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';
import Modal from 'components/shared/DesignSystem/Modal';
import styled from 'styled-components';
import { Button } from '@companycam/slab-web';

const StyledModal = styled(Modal)`
  width: 550px;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 20px;
`;
const Msg = styled.p`
  font-weight: 600;
  font-size: 24px;
`;

const SuccessCheck = styled.i`
  font-size: 85px;
  margin-bottom: 20px;
  color: var(--cc_color_button_background_secondary);
`;

const messages = defineMessages({
  completeMessage: {
    id: 'Projects.taskList.exportPdf.completeMessage',
    defaultMessage: `We've received your request and are currently building your checklist PDF.`,
    description: 'Message for triggering export',
  },
  completeDescription: {
    id: 'Projects.taskList.exportPdf.completeDescription',
    defaultMessage: `We'll send you a notification when it's ready to go. This shouldn't take more than a minute or two.`,
    description: 'Description for triggering export',
  },
  savedDescription: {
    id: 'Projects.taskList.exportPdf.savedDescription',
    defaultMessage: `A copy will also be saved to your project documents.`,
    description: 'Description for successful save',
  },
});

const ExportCompleteModal = ({ isOpen, onRequestClose, savedToDocuments }) => {
  const { formatMessage } = useIntl();

  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-content-wrap"
    >
      <ModalContainer>
        <SuccessCheck className="mdi mdi-file-clock" />
        <Msg>{formatMessage(messages.completeMessage)}</Msg>
        <p className="instructions">
          {formatMessage(messages.completeDescription)}

          {savedToDocuments ? (
            <>
              <br />
              {formatMessage(messages.savedDescription)}
            </>
          ) : null}
        </p>
      </ModalContainer>

      <div className="btn-container">
        <Button color="primary" onClick={onRequestClose}>
          {formatMessage({ id: 'Common.gotIt' })}
        </Button>
      </div>
    </StyledModal>
  );
};

ExportCompleteModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  savedToDocuments: PropTypes.bool,
};

export default ExportCompleteModal;
